import { render } from "./OpenCalendar.vue?vue&type=template&id=885e1404&scoped=true"
import script from "./OpenCalendar.vue?vue&type=script&lang=js"
export * from "./OpenCalendar.vue?vue&type=script&lang=js"

import "./OpenCalendar.vue?vue&type=style&index=0&id=885e1404&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-885e1404"]])

export default __exports__